import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  createCharterReferral,
  deleteCharterReferral,
  listCharterReferral,
  updateCharterReferral,
} from '~/services/CharterReferralService';

import type {
  CreateCharterReferralBody,
  ListCharterReferralParams,
  UpdateCharterReferralBody,
} from '~/types/charterReferral';

import { charterReferralQueryKeys } from './charterReferralQueryKeys';

interface UpdateCharterReferralParams {
  body: UpdateCharterReferralBody;
}

export function useGetCharterReferralList(
  params: Partial<ListCharterReferralParams> = {},
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: charterReferralQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await listCharterReferral(params, { signal });
    },
    enabled,
  });
}

export function useCreateCharterReferral() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateCharterReferralBody) => {
      return await createCharterReferral(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterReferralQueryKeys.all });
    },
  });
}

export function useUpdateCharterReferral() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ body }: UpdateCharterReferralParams) => {
      return await updateCharterReferral(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterReferralQueryKeys.all });
    },
  });
}

export function useDeleteCharterReferral() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fnfReferralIds: Array<string>) => {
      return await deleteCharterReferral(fnfReferralIds);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterReferralQueryKeys.all });
    },
  });
}
